<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :fill="fill" d="M8.225 9.46578H1.4C0.625 9.46578 0 8.7421 0 7.84473V1.62105C0 0.723677 0.625 0 1.4 0H8.225C9 0 9.625 0.723677 9.625 1.62105V7.84473C9.625 8.7421 9 9.46578 8.225 9.46578ZM2 7.14999H7.625V2.31579H2V7.14999ZM20.6 9.46578H13.775C13 9.46578 12.375 8.7421 12.375 7.84473V1.62105C12.375 0.723677 13 0 13.775 0H20.6C21.375 0 22 0.723677 22 1.62105V7.84473C22 8.7421 21.375 9.46578 20.6 9.46578ZM14.375 7.14999H20V2.31579H14.375V7.14999ZM8.225 22H1.4C0.625 22 0 21.2763 0 20.379V14.1553C0 13.2579 0.625 12.5342 1.4 12.5342H8.225C9 12.5342 9.625 13.2579 9.625 14.1553V20.379C9.625 21.2763 9 22 8.225 22ZM2 19.6842H7.625V14.85H2V19.6842ZM20.6 22H13.775C13 22 12.375 21.2763 12.375 20.379V14.1553C12.375 13.2579 13 12.5342 13.775 12.5342H20.6C21.375 12.5342 22 13.2579 22 14.1553V20.379C22 21.2763 21.375 22 20.6 22ZM14.375 19.6842H20V14.85H14.375V19.6842Z"/>
  </svg>
</template>

<script>
  export default {
    name: 'vidgetsIcon',
    props: {
      fill: {
        type: String,
        required: false
      }
    }
  }
</script>
